<div class="licenseComp">
    <h1>Vehicle Rent Approvals</h1>
    <div class="mt-20">

        <table mat-table [dataSource]="vehicleRents" class="mat-elevation-z8">

            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef> ID. </th>
                <td mat-cell *matCellDef="let element"> {{element.id}} </td>
            </ng-container>

            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef> Name </th>
                <td mat-cell *matCellDef="let element"> {{element.user.name}} {{element.user.surname}}</td>
            </ng-container>

            <ng-container matColumnDef="company">
                <th mat-header-cell *matHeaderCellDef> Company </th>
                <td mat-cell *matCellDef="let element"> {{element.company.name}} </td>
            </ng-container>

            <ng-container matColumnDef="plate">
                <th mat-header-cell *matHeaderCellDef> Plate </th>
                <td mat-cell *matCellDef="let element"> {{element.plaka}} </td>
            </ng-container>

            <ng-container matColumnDef="brand">
                <th mat-header-cell *matHeaderCellDef> Brand </th>
                <td mat-cell *matCellDef="let element"> {{element.brand}} </td>
            </ng-container>

            <ng-container matColumnDef="model">
                <th mat-header-cell *matHeaderCellDef> Model </th>
                <td mat-cell *matCellDef="let element"> {{element.model}} </td>
            </ng-container>

            <ng-container matColumnDef="year">
                <th mat-header-cell *matHeaderCellDef> Year </th>
                <td mat-cell *matCellDef="let element"> {{element.year}} </td>
            </ng-container>

            <ng-container matColumnDef="price">
                <th mat-header-cell *matHeaderCellDef> Price </th>
                <td mat-cell *matCellDef="let element"> {{element.price}} </td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef> Status </th>
                <td mat-cell *matCellDef="let element"> {{element.status}} </td>
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="tableClick(row)"></tr>
        </table>

    </div>
</div>